/* globals customEase */

import './vendor';
import Parser from 'ua-parser-js';
import AOS from 'aos';
import {helpers} from './common/helpers';

let ua = new Parser();


$('html').addClass(`is-browser-${ua.getBrowser().name.toLowerCase()} is-os-${ua.getOS().name.toLowerCase()}`);

helpers.sizeRedirect();
helpers.checkMobile();

window.dsp_question = function(){
	// console.log( 'dsp_question' );
	try {
		DSPCounter('send', {
		  'sid'       : '221170',
		  'site_area' : 'cVMnd4Vn',
		  'user_id'   : '',
		  'lead_id'   : '',
		  'order_sum' : ''
		});
	}catch(e){}
}

window.dsp_consult = function(){
	// console.log( 'dsp_consult' );
	try {
		DSPCounter('send', {
		  'sid'       : '221170',
		  'site_area' : 'uWZd8EMk',
		  'user_id'   : '',
		  'lead_id'   : '',
		  'order_sum' : ''
		});
	}catch(e){}
}

window.dsp_overview = function(){
	// console.log( 'dsp_overview' );
	try {
		DSPCounter('send', {
		  'sid'       : '221170',
		  'site_area' : 'gsRzRFBD',
		  'user_id'   : '',
		  'lead_id'   : '',
		  'order_sum' : ''
		});
	}catch(e){}
}

AOS.init({
	once: true,
	duration: 600,
	disable: window.innerWidth <= 1024,
});

$(document).on('hero.isShown', () => {
	setTimeout(AOS.refreshHard, 150);
});

$(document).on('tabs.tabChange', () => {
	setTimeout(AOS.refreshHard, 150);
});

$(window).on('scroll', () => {
	window.scrollDirection = helpers.getScrollDirection();
});

$(window).on('resize', () => {
	helpers.sizeRedirect();
});

// custom easing functions to use in tween options by id(first param here)
customEase.create('default', '.25,.1,.25,1');
customEase.create('heroElems', '.4,0,.4,1');
customEase.create('heroSlider', '.4,0,.2,1');
customEase.create('sliderEase', '.62,.12,.52,.94');
customEase.create('easeBoth', '.42,0,.58,1');

import './modules/sliders';
import './modules/scroll';
import './modules/forms';
import './modules/modals';
import './modules/tabs';
import './modules/maps';
import './modules/menu';
import './modules/other';
import './modules/video';
import './common/share';

$('.banks-slider__item').click(function(){
	try {
		switch( window.__current_slug ){
			case 'futuro':
				ym(51706139,'reachGoal','fut_click_ipoteka');
				gtag('event', 'fut_click', { 'event_category' : 'banki' });	
				break;
			case 'avenue':
				ym(51706139,'reachGoal','ave_click_ipoteka');
				gtag('event', 'ave_click', { 'event_category' : 'banki' });	
				break;
			case 'fonte':
				ym(51706139,'reachGoal','font_click_ipoteka');
				gtag('event', 'font_click', { 'event_category' : 'banki' });
				break;
		}
	}catch(e){
		console.log('Some stat event error occured');
	}
});